import React, {useContext, useEffect, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import SaleController from "../../../../stories/_operation/Sale/SaleController";
import BackofficeContext from "../../../../context/BackofficeContext";
import ListingContext from "../../../../context/ListingContext";
import LoaderCircle from "../../../loader/LoaderCircle";
import Ticket from "../ticket/Ticket";
import TicketV2 from "../ticket/TicketV2";
import "../../../../css/page/content/sale/PreviewBox.css";
import CancelIcon from "../../../icons/CancelIcon";

const PreviewBox = props => {
    const { previousLink, type } = props;
    const [ loading, setLoading ] = useState(true);
    const [ sale, setSale ] = useState(null);
    const { setEvent } = useContext(BackofficeContext);
    const { savePage } = useContext(ListingContext);
    const urlParams = useParams();
    const history = useHistory();

    const getSale = () => {
        const controller = new SaleController();
        controller._callback = handleGetSale;
        controller.show(urlParams.id);
    }
    const handleGetSale = (object, error, status) => {
        setLoading(false);

        switch (status) {
            case 200:
                setSale(object)
                break
            case 404:
                setEvent({
                    type: "error",
                    text: "Vente introuvable !"
                });
                break
            default:
                setEvent({
                    type: "error",
                    text: "Une erreur s'est produite (" + status + ")"
                });
                break
        }
    }
    const callCloseSheet = () => {
        history.push("/" + previousLink + ((savePage !== undefined && savePage !== 1) ? "/page/" + savePage : ""));
    }
    const returnDatasToPrint = () => {
        const controller = new SaleController();
        return controller.datasToPrint(sale);
    }
    const returnDatasToPreview = () => {
        const controller = new SaleController();
        return controller.datasToPreview(sale);
    }

    useEffect(() => {
        getSale();
    }, []);

    return (
        <>
            {
                (!loading && sale !== null)
                && <div className={"overlayer"} />
            }
            <div className={"overbox previewSale" + (loading || sale === null ? " loading" : "")}>
                {
                    (loading || sale === null)
                        ? <div className="containerLoaderPreview">
                            <div className={"block"}>
                                <p>Ouverture de la vente...</p>
                                <LoaderCircle display="loader" strokeWidth="10" stroke={"#9C9C9C"} />
                            </div>
                            <CancelIcon classname={"close"} click={ callCloseSheet } />
                        </div>
                        : <div className={"previewBox"}>
                            <div className={"containerTicket"}>
                                {
                                    type === "v1" && <Ticket datas={ returnDatasToPrint() } />
                                }
                                {
                                    type === "v2" && <TicketV2 sale={ returnDatasToPreview() } />
                                }
                            </div>
                            <div className={"wrapButtons"}>
                                <button className="cancel block margin marginBottom" onClick={ callCloseSheet }>Fermer</button>
                            </div>
                        </div>
                }
            </div>
        </>
    )
}

export default PreviewBox;
